module.exports = __webpack_public_path__ + "static/media/fan coral 1.2.efc5ebe7.svg";